import React from 'react'
import { LayoutBand, Skeleton, colors, useContainerWidth } from '@fs/zion-ui'
import { css } from '@emotion/core'

const horizontalDivCss = css`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
`

const horizontalDivHeadingCss = css`
  width: 100%;
`

const Horizontal = () => {
  return (
    <div data-testid="AffinityOverviewCardSkeleton_horizontal" css={horizontalDivCss}>
      <div>
        <Skeleton.Image height="200px" width="200px" />
      </div>
      <div css={horizontalDivHeadingCss}>
        <Skeleton.H3 />
        <Skeleton.Paragraph lineCount={3} size="md" />
        <Skeleton.Button />
      </div>
    </div>
  )
}

const Vertical = () => {
  return (
    <div data-testid="AffinityOverviewCardSkeleton_vertical">
      <Skeleton.Image height="200px" width="200px" />
      <div>
        <Skeleton.H3 />
        <Skeleton.Paragraph lineCount={3} size="md" />
        <Skeleton.Button />
      </div>
    </div>
  )
}

export default function AffinityOverviewCardSkeleton() {
  const atWidth = useContainerWidth()

  return (
    <LayoutBand color={colors.blue02}>
      <div style={{ padding: '40px' }} data-testid="AffinityOverviewCardSkeleton">
        {atWidth({
          default: <Vertical />,
          md: <Horizontal />,
        })}
      </div>
    </LayoutBand>
  )
}
